// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4ce42bc0","41":"e86f3718","63":"cf058695","189":"ed7e1bc2","204":"8f2eda1d","479":"9b5d6a3a","589":"49ddad0a","649":"4125b3af","690":"8155a521","754":"e56aa96b","840":"80456c6b","940":"02561579"}[chunkId] + ".chunk.js";
};